import { Link } from "@inertiajs/react"
import type { ComponentProps } from "react"

import { cn } from "@/lib/utils"

type LinkProps = ComponentProps<typeof Link>

export function TextLink({ className = "", children, ...props }: LinkProps) {
  return (
    <Link
      className={cn(
        "text-foreground decoration-accent-dim underline underline-offset-4 transition-colors duration-300 ease-out hover:decoration-current!",
        className,
      )}
      {...props}
    >
      {children}
    </Link>
  )
}
